module.exports = __webpack_public_path__ + "static/media/page3.d795d914.ogg";